import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./CaseFormPopup.css";
import Quill from "quill";
import Translate from "../helpers/Translate";

// Register custom size style for pixel values

import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Conversation } from "@twilio/conversations/lib/conversation";

const Size = Quill.import("attributors/style/size");
Size.whitelist = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "24px",
  "32px",
  "48px",
];
Quill.register(Size, true);

// Loader state setter for Quill image upload
let setQuillUploading = null;
const imageHandler = function () {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("accept", "image/*");
  input.click();
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("files", file);
    formData.append("container", "public"); // adjust as needed
    formData.append("provider", "MYMA"); // adjust as needed
    if (typeof setQuillUploading === "function") setQuillUploading(true);
    try {
      const resp = await fetch(process.env.REACT_APP_API_URL + "/upload-file", {
        method: "POST",
        body: formData,
      });
      const data = await resp.json();
      console.log("File upload response:", data);
      if (Array.isArray(data) && data.length > 0 && data[0].link) {
        const quill = this.quill || window.quillRef;
        const range = quill.getSelection();
        quill.insertEmbed(range.index, "image", data[0].link);
      } else if (
        data &&
        data.files &&
        Array.isArray(data.files) &&
        data.files[0].link
      ) {
        // If your server returns { files: [{ link, name }] }
        const quill = this.quill || window.quillRef;
        const range = quill.getSelection();
        quill.insertEmbed(range.index, "image", data.files[0].link);
      } else {
        console.log("Image upload failed.");
      }
    } catch (err) {
      console.log("Image upload error: " + err.message);
    } finally {
      if (typeof setQuillUploading === "function") setQuillUploading(false);
    }
  };
};
// Loader style for Quill overlay
const quillLoaderStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(255,255,255,0.7)",
  zIndex: 2000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const quillModules = {
  toolbar: {
    container: [
      [{ font: [] }],
      [
        {
          size: [
            "10px",
            "12px",
            "14px",
            "16px",
            "18px",
            "24px",
            "32px",
            "48px",
          ],
        },
      ],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
    handlers: {
      image: imageHandler,
    },
  },
};
class CaseFormPopup extends Component {
  quillRef = null;

  handleCopyCaseNumber = async () => {
    const text = this.state.caseNumber;

    try {
      if (navigator?.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        throw new Error("Clipboard API not available");
      }
    } catch (err) {
      // fallback
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
  };
  // Prefill fields from an object (used by parent via ref)
  prefillFields = async (fields = {}) => {
    this.setState({ prefillLoading: true });
    try {
      // Always show the popup first
      if (!this.state.show) this.setState({ show: true });
      // Only set fields that exist in state
      const allowed = ["system", "scenario", "topic", "subject", "description"];
      const update = {};
      for (const key of allowed) {
        if (fields[key] !== undefined) update[key] = fields[key];
      }

      console.log("Prefilling case form with:", update);

      // 4. Set subject and description using handleChange for controlled updates
      if (update.subject) {
        await this.handleChange({
          target: { name: "subject", value: update.subject },
        });
      }
      if (update.description) {
        await this.handleChange({
          target: { name: "description", value: update.description },
        });
      }

      // 1. Set system and wait for systems to load if needed
      if (update.system) {
        if (!this.state.systems.length) {
          await this.fetchSystems();
        }
        await new Promise((resolve) =>
          this.setState({ system: update.system }, resolve),
        );
        await this.handleChange({
          target: { name: "system", value: update.system },
        });
        // Wait for scenarios to load
        await new Promise((resolve) => {
          const check = () => {
            if (this.state.scenarios.length) resolve();
            else setTimeout(check, 50);
          };
          check();
        });
      }
      // 2. Set scenario and wait for topics to load if needed
      if (update.scenario) {
        await new Promise((resolve) =>
          this.setState({ scenario: update.scenario }, resolve),
        );
        await this.handleChange({
          target: { name: "scenario", value: update.scenario },
        });
        await new Promise((resolve) => {
          const check = () => {
            if (this.state.topics.length) resolve();
            else setTimeout(check, 50);
          };
          check();
        });
      }
      // 3. Set topic
      if (update.topic) {
        await new Promise((resolve) =>
          this.setState({ topic: update.topic }, resolve),
        );
      }
    } finally {
      this.setState({ prefillLoading: false });
    }
  };
  constructor(props) {
    super(props);
    console.log("CaseFormPopup props:", props);
    this.state = {
      system: "",
      scenario: "",
      topic: "",
      subject: "",
      description: "",
      show: true,
      systems: [],
      systemsLoading: false,
      systemsError: null,
      scenarios: [],
      scenariosLoading: false,
      scenariosError: null,
      topics: [],
      topicsLoading: false,
      topicsError: null,
      submitLoading: false,
      caseNumberModal: false,
      caseId: "",
      prefillLoading: false,
      quillUploading: false,
      caseNumber: "",
    };
  }

  componentDidMount() {
    setQuillUploading = (flag) => this.setState({ quillUploading: flag });
    this.fetchSystems();
    // If the popup is already shown on mount, attempt AI prefill
    if (this.state.show && !this._aiPrefilled) {
      this.fetchAiPrefill();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // When the popup is opened, fetch AI prefill if we haven't already
    if (!prevState.show && this.state.show && !this._aiPrefilled) {
      this.fetchAiPrefill();
    }

    // If parent provided a pending prefill prop after mount, apply it
    if (
      prevProps.pendingPrefill !== this.props.pendingPrefill &&
      this.props.pendingPrefill &&
      !this._aiPrefilled
    ) {
      this._aiPrefilled = true;
      this.setState({ prefillLoading: true }, async () => {
        try {
          await this.prefillFields(this.props.pendingPrefill);
        } catch (e) {
          console.error("Error applying pending prefill on update", e);
        } finally {
          this.setState({ prefillLoading: false });
        }
      });
    }
  }

  fetchAiPrefill = async () => {
    this._aiPrefilled = true; // avoid duplicate calls
    this.setState({ prefillLoading: true });
    // Build chat history: prefer explicit prop, fallback to store state
    let chatHistory = this.props.chatHistory;
    if (!chatHistory) {
      try {
        let storeState = null;
        if (
          this.props.store &&
          typeof this.props.store.getState === "function"
        ) {
          storeState = this.props.store.getState();
        } else if (
          this.props.bookingApp &&
          this.props.bookingApp.callbacks &&
          typeof this.props.bookingApp.callbacks.getStore === "function"
        ) {
          storeState = this.props.bookingApp.callbacks.getStore().getState();
        }
        if (storeState) {
          chatHistory =
            require("../ChatStore").getChatHistoryForAgent(storeState);
        }
      } catch (e) {
        console.error("Failed to build chat history for AI prefill", e);
      }
    }

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/ai-classify-case`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ conversationLogs: chatHistory }),
        },
      );
      let aiCaseData = null;
      if (resp.ok) aiCaseData = await resp.json();

      if (aiCaseData && aiCaseData.arguments) {
        let args = {};
        try {
          args = JSON.parse(aiCaseData.arguments);
        } catch (e) {
          console.error("Failed to parse AI case data arguments", e);
        }

        const prefillObj = {
          system: args.system || aiCaseData.system || "",
          scenario: args.scenario || aiCaseData.scenario || "",
          topic: args.topic || aiCaseData.topic || "",
          subject: args.subject || aiCaseData.subject || "",
          description:
            args.case_description ||
            aiCaseData.case_description ||
            aiCaseData.description ||
            "",
        };

        // Ensure systems are loaded before prefill if necessary
        if (!this.state.systems.length) await this.fetchSystems();

        try {
          await this.prefillFields(prefillObj);
        } catch (e) {
          console.error("Error pre-filling fields from AI response", e);
        }
      }
    } catch (err) {
      console.error("Failed to fetch AI case data", err);
    } finally {
      this.setState({ prefillLoading: false });
    }
  };

  fetchSystems = async () => {
    this.setState({ systemsLoading: true, systemsError: null });
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/systems`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );
      if (!resp.ok) throw new Error("Failed to fetch systems");
      const data = await resp.json();
      // Expecting array of system names or objects with name property
      this.setState({
        systems: Array.isArray(data) ? data : [],
        systemsLoading: false,
      });
    } catch (err) {
      this.setState({ systemsError: err.message, systemsLoading: false });
    }
  };

  open = () => this.setState({ show: true });
  close = () => {
    this.setState({ show: false });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  handleChange = async (e) => {
    // For ReactQuill, e can be a string (HTML)
    if (e && e.target) {
      const { name, value } = e.target;
      this.setState({ [name]: value });
      if (name === "system") {
        this.setState({
          scenario: "",
          scenarios: [],
          scenariosLoading: true,
          scenariosError: null,
          topic: "",
          topics: [],
          topicsLoading: false,
          topicsError: null,
        });
        try {
          const resp = await fetch(
            `${process.env.REACT_APP_PARTNER_URL}/salesforce/system-scenario`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ system: value }),
            },
          );
          if (!resp.ok) throw new Error("Failed to fetch scenarios");
          const data = await resp.json();
          this.setState({
            scenarios: Array.isArray(data) ? data : [],
            scenariosLoading: false,
          });
        } catch (err) {
          this.setState({
            scenariosError: err.message,
            scenariosLoading: false,
            prefillLoading: false,
          });
        }
      }
      if (name === "scenario") {
        this.setState({
          topic: "",
          topics: [],
          topicsLoading: true,
          topicsError: null,
        });
        try {
          const resp = await fetch(
            `${process.env.REACT_APP_PARTNER_URL}/salesforce/scenario-topics`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                system: this.state.system,
                scenario: value,
              }),
            },
          );
          if (!resp.ok) throw new Error("Failed to fetch topics");
          const data = await resp.json();
          this.setState({
            topics: Array.isArray(data) ? data : [],
            topicsLoading: false,
          });
        } catch (err) {
          this.setState({
            topicsError: err.message,
            topicsLoading: false,
            prefillLoading: false,
          });
        }
      }
    } else if (typeof e === "string") {
      // ReactQuill change
      this.setState({ description: e });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitLoading: true });
    // Remove single quotes from system, scenario, and topic
    const clean = (val) =>
      typeof val === "string" ? val.replace(/'/g, "") : val;
    // Prepend System, Scenario, Topic to description
    const systemLabel = this.state.system ? `System: ${this.state.system}` : "";
    const scenarioLabel = this.state.scenario
      ? `Scenario: ${this.state.scenario}`
      : "";
    const topicLabel = this.state.topic ? `Topic: ${this.state.topic}` : "";
    // Append chat history if provided
    let chatHistory = this.props.chatHistory;
    //console.log("Original chat history:", chatHistory);
    let chatHistorySection = chatHistory
      ? `\n\nChat History:\n${chatHistory}`
      : "";
    let descriptionWithLabels =
      [
        systemLabel,
        scenarioLabel,
        topicLabel,
        "Chat Summary:",
        this.state.description,
      ]
        .filter(Boolean)
        .join("\n\n") + chatHistorySection;
    // Truncate to max 32000 characters
    if (descriptionWithLabels.length > 32000) {
      descriptionWithLabels = descriptionWithLabels.slice(0, 32000);
    }
    console.log("this.props.accountId", this.props.accountId);
    console.log("this.props.contactId", this.props.contactId);
    const body = {
      System__c: clean(this.state.system),
      Scenario__c: clean(this.state.scenario),
      Topic__c: clean(this.state.topic),
      AccountId: this.props.accountId,
      ContactId: this.props.contactId,
      Subject: this.state.subject,
      Description: descriptionWithLabels,
      RecordTypeId: "012600000004vJ7AAI",
      Origin: "Web: Support Services Portal - CCD",
      GroupId: this.props.gid,
      ConversationId: this.props.directline.conversationId,
    };
    // Print body as JSON string
    console.log(JSON.stringify(body));
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_PARTNER_URL}/salesforce/case`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      );
      const data = await resp.json();
      console.log("Case creation response:", data);
      //console.log("Case creation response status:", resp.ok, resp.status);
      if (!resp.ok) {
        this.setState({
          submitLoading: false,
          genericError: true,
        });
        return;
      }
      if (data && data.CaseNumber) {
        this.setState({
          submitLoading: false,
          caseNumberModal: true,
          caseNumber: data.CaseNumber,
          caseId: data.caseId,
          show: false, // Hide the previous popup
        });

        // Use Translate component for localized message
        // const msg = (
        //   <Translate
        //     input={`Case Created!\nCase Number: ${data.CaseNumber}`}
        //     lang={this.props.lang || "en"}
        //   />
        // );
        const msg = `Case Created!\nCase Number: [${data.CaseNumber}](https://avenhospitality--cert.sandbox.my.site.com/CustomerCommunity/s/case/${data.caseId}/)`;
        console.log("Dispatching handover_to_salesforce with message:", msg);
        if (this.props.directline && this.props.directline.conversationId) {
          fetch(process.env.REACT_APP_API_URL + "/sendmessageactivityByBot", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              conversationId: this.props.directline.conversationId,
              message: msg,
              from: Math.random(),
              summary: "",
            }),
          }).catch((err) => {
            console.error("Bmb ticket creation failed :(.\n", err);
          });

          var msgpayload = {
            gid: this.props.gid,
            iid: this.props.iid,
            pid: this.props.pid,
            vid: this.props.vid,
            sid: this.props.sid,
            cid: this.props.directline.conversationId,
            time: new Date().toISOString(),
            source: "Bot",
            message: msg,
            tag: "",
            agentId: "",
          };
          fetch(process.env.REACT_APP_API_URL + "/saveMessage", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(msgpayload),
          }).catch((err) => {
            console.error("Bmb livechat logging failed :(.");
            console.error(err);
          });
        }
      } else {
        this.setState({ submitLoading: false });
        this.close();
      }
      if (this.props.onSubmit) {
        this.props.onSubmit(data);
      }
      if (this.props.loadClosedCases) {
        this.props.loadClosedCases();
      }
    } catch (err) {
      this.setState({
        submitLoading: false,
        genericError: true,
      });
      // alert("Error creating case: " + err.message);
    }
  };

  render() {
    const {
      show,
      system,
      scenario,
      topic,
      subject,
      description,
      systems,
      systemsLoading,
      systemsError,
      scenarios,
      scenariosLoading,
      scenariosError,
      topics,
      topicsLoading,
      topicsError,
    } = this.state;
    return (
      <>
        <Modal isOpen={show} toggle={this.close}>
          <ModalHeader toggle={this.close}>
            <FormattedMessage
              id="caseform.title"
              defaultMessage="Submit a Case"
            />
          </ModalHeader>
          {/* Loader overlay for prefill */}
          {this.state.prefillLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.7)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="modern-spinner"></div>
            </div>
          )}
          {this.state.submitLoading ? (
            <div className="container">
              <div className="modern-spinner"></div>
            </div>
          ) : (
            <Form onSubmit={this.handleSubmit}>
              <ModalBody
                style={{
                  height: "calc(99vh - 72px)", // 72px is approx header+footer height
                  minHeight: "400px",
                  overflowY: "auto",
                  paddingBottom: 0,
                }}
              >
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="system">
                    <FormattedMessage
                      id="caseform.system"
                      defaultMessage="System"
                    />
                  </Label>
                  <Input
                    type="select"
                    name="system"
                    id="system"
                    value={system}
                    onChange={this.handleChange}
                    required
                    disabled={systemsLoading}
                  >
                    {systemsLoading ? (
                      <FormattedMessage
                        id="caseform.loading.systems"
                        defaultMessage="Loading systems..."
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id="caseform.select.system"
                        defaultMessage="Select System"
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {systemsError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id="caseform.error.systems"
                          defaultMessage="Error loading systems"
                        />
                      </option>
                    )}
                    {Array.isArray(systems) &&
                      systems.map((sys, idx) => {
                        let value =
                          typeof sys === "object" && sys !== null
                            ? (sys.name ?? "")
                            : sys;
                        let label =
                          typeof sys === "object" && sys !== null
                            ? (sys.name ?? "")
                            : sys;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="scenario">
                    <FormattedMessage
                      id="caseform.scenario"
                      defaultMessage="Scenario"
                    />
                  </Label>
                  <Input
                    type="select"
                    name="scenario"
                    id="scenario"
                    value={scenario}
                    onChange={this.handleChange}
                    required
                    disabled={scenariosLoading || !system}
                  >
                    {scenariosLoading ? (
                      <FormattedMessage
                        id="caseform.loading.scenarios"
                        defaultMessage="Loading scenarios..."
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id="caseform.select.scenario"
                        defaultMessage="Select Scenario"
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {scenariosError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id="caseform.error.scenarios"
                          defaultMessage="Error loading scenarios"
                        />
                      </option>
                    )}
                    {Array.isArray(scenarios) &&
                      scenarios.map((sc, idx) => {
                        let value =
                          typeof sc === "object" && sc !== null
                            ? (sc.name ?? "")
                            : sc;
                        let label =
                          typeof sc === "object" && sc !== null
                            ? (sc.name ?? "")
                            : sc;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="topic">
                    <FormattedMessage
                      id="caseform.topic"
                      defaultMessage="Topic"
                    />
                  </Label>
                  <Input
                    type="select"
                    name="topic"
                    id="topic"
                    value={topic}
                    onChange={this.handleChange}
                    required
                    disabled={topicsLoading || !scenario}
                  >
                    {topicsLoading ? (
                      <FormattedMessage
                        id="caseform.loading.topics"
                        defaultMessage="Loading topics..."
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id="caseform.select.topic"
                        defaultMessage="Select Topic"
                      >
                        {(msg) => <option value="">{msg}</option>}
                      </FormattedMessage>
                    )}
                    {topicsError && (
                      <option value="" disabled>
                        <FormattedMessage
                          id="caseform.error.topics"
                          defaultMessage="Error loading topics"
                        />
                      </option>
                    )}
                    {Array.isArray(topics) &&
                      topics.map((tp, idx) => {
                        let value =
                          typeof tp === "object" && tp !== null
                            ? (tp.name ?? "")
                            : tp;
                        let label =
                          typeof tp === "object" && tp !== null
                            ? (tp.name ?? "")
                            : tp;
                        return (
                          <option key={value || idx} value={value}>
                            {label}
                          </option>
                        );
                      })}
                  </Input>
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="subject">
                    <FormattedMessage
                      id="caseform.subject"
                      defaultMessage="Subject"
                    />
                  </Label>
                  <Input
                    type="text"
                    name="subject"
                    id="subject"
                    value={subject}
                    onChange={this.handleChange}
                    required
                  />
                </FormGroup>
                {/* ...existing code... */}
                <FormGroup>
                  <Label for="description">
                    <FormattedMessage
                      id="caseform.description"
                      defaultMessage="Description"
                    />
                  </Label>
                  <div style={{ position: "relative" }}>
                    <ReactQuill
                      ref={(el) => {
                        this.quillRef = el;
                        if (el && el.getEditor) {
                          window.quillRef = el.getEditor();
                        }
                      }}
                      theme="snow"
                      value={description}
                      onChange={this.handleChange}
                      modules={quillModules}
                      style={{
                        minHeight: 120,
                        height: "30vh",
                        maxHeight: "40vh",
                      }}
                    />
                    {this.state.quillUploading && (
                      <div style={quillLoaderStyle}>
                        <div className="modern-spinner"></div>
                      </div>
                    )}
                  </div>
                </FormGroup>
                {/* ...existing code... */}
              </ModalBody>
              <ModalFooter
                style={{
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 10,
                  borderTop: "1px solid #eee",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <Button
                  color="primary"
                  type="submit"
                  style={
                    this.props.buttonColor
                      ? {
                          backgroundColor: this.props.buttonColor,
                          borderColor: this.props.buttonColor,
                          color: "#fff",
                        }
                      : undefined
                  }
                >
                  <FormattedMessage
                    id="caseform.submit"
                    defaultMessage="Submit"
                  />
                </Button>{" "}
                <Button
                  color="secondary"
                  onClick={this.close}
                  type="button"
                  style={
                    this.props.buttonColor
                      ? {
                          backgroundColor: this.props.buttonColor,
                          borderColor: this.props.buttonColor,
                          color: "#fff",
                        }
                      : undefined
                  }
                >
                  <FormattedMessage
                    id="caseform.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Modal>
        {/* Success Modal */}
        <Modal
          isOpen={this.state.caseNumberModal}
          toggle={() => {
            this.setState({
              caseNumberModal: false,
              caseId: "",
              caseNumber: "",
            });
            this.close();
          }}
        >
          <ModalHeader
            toggle={() => {
              this.setState({
                caseNumberModal: false,
                caseId: "",
                caseNumber: "",
              });
              this.close();
            }}
          >
            <FormattedMessage
              id="caseform.success.title"
              defaultMessage="Case Created"
            />
          </ModalHeader>
          <ModalBody>
            <div style={{ marginBottom: 16 }}>
              <FormattedMessage
                id="caseform.success.message"
                defaultMessage="Your case has been created successfully."
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 12,
                marginBottom: 8,
              }}
            >
              <strong style={{ minWidth: 110 }}>
                <FormattedMessage
                  id="caseform.success.caseNumber"
                  defaultMessage="Case Number:"
                />
              </strong>
              <span
                style={{ fontSize: 18, fontWeight: 500, letterSpacing: 0.5 }}
              >
                {this.state.caseNumber !== "" && this.state.caseId !== "" ? (
                  <a
                    href={`https://avenhospitality--cert.sandbox.my.site.com/CustomerCommunity/s/case/${this.state.caseId}/`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {this.state.caseNumber}
                  </a>
                ) : (
                  this.state.caseNumber
                )}
              </span>
              {this.state.caseNumber !== "" && (
                <span
                  title="Copy case number"
                  onClick={this.handleCopyCaseNumber}
                  style={{
                    cursor: "pointer",
                    color: "#007bff",
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "2px 6px",
                    borderRadius: 4,
                    transition: "background 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#e6f0fa")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ verticalAlign: "middle" }}
                  >
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      ry="2"
                    ></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                  </svg>
                </span>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                this.setState({
                  caseNumberModal: false,
                  caseId: "",
                  caseNumber: "",
                });
                this.close();
              }}
              style={
                this.props.buttonColor
                  ? {
                      backgroundColor: this.props.buttonColor,
                      borderColor: this.props.buttonColor,
                      color: "#fff",
                    }
                  : undefined
              }
            >
              <FormattedMessage id="caseform.success.ok" defaultMessage="OK" />
            </Button>
          </ModalFooter>
        </Modal>
        {/* Generic Error Modal */}
        {this.state.genericError && (
          <Modal
            isOpen={this.state.genericError}
            toggle={() => {
              this.setState({ genericError: false });
              this.close();
            }}
          >
            <ModalHeader
              toggle={() => {
                this.setState({ genericError: false });
                this.close();
              }}
            >
              <FormattedMessage
                id="caseform.error.generic"
                defaultMessage="An error occurred while creating your case. Please try again later."
              />
            </ModalHeader>
            <ModalBody>
              <div style={{ marginBottom: 16 }}>
                <FormattedMessage
                  id="caseform.error.generic.message"
                  defaultMessage="An error occurred while creating your case. Please try again later."
                />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  this.setState({ genericError: false });
                  this.close();
                }}
                style={
                  this.props.buttonColor
                    ? {
                        backgroundColor: this.props.buttonColor,
                        borderColor: this.props.buttonColor,
                        color: "#fff",
                      }
                    : undefined
                }
              >
                <FormattedMessage
                  id="caseform.success.ok"
                  defaultMessage="OK"
                />
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }
}

export default CaseFormPopup;
